import { SVGProps } from 'react';
const SvgArrowDownRightMd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m7 7 10 10M17 9v8H9"
    />
  </svg>
);
export default SvgArrowDownRightMd;
